"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TextVisualizationManager_drawingToolsManager, _TextVisualizationManager_labelRenderer, _TextVisualizationManager_parentNode, _TextVisualizationManager_settings, _TextVisualizationManager_viewport, _TextVisualizationManager_visualizationNode, _TextVisualizationManager_distanceObject3D, _TextVisualizationManager_object3D, _TextVisualizationManager_positionObject3D, _TextVisualizationManager_showDistanceLabels, _TextVisualizationManager_showPointLabels, _TextVisualizationManager_prevWidth, _TextVisualizationManager_prevHeight;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextVisualizationManager = void 0;
const THREE = __importStar(require("three"));
const viewer_1 = require("@shapediver/viewer");
const CSS2DRenderer_1 = require("../../../three/CSS2DRenderer");
const numberCleaner_1 = require("../utils/numberCleaner");
const gl_matrix_1 = require("gl-matrix");
class TextVisualizationManager {
    // #endregion Properties (11)
    // #region Constructors (1)
    constructor(drawingToolsManager) {
        // #region Properties (11)
        _TextVisualizationManager_drawingToolsManager.set(this, void 0);
        _TextVisualizationManager_labelRenderer.set(this, void 0);
        _TextVisualizationManager_parentNode.set(this, void 0);
        _TextVisualizationManager_settings.set(this, void 0);
        _TextVisualizationManager_viewport.set(this, void 0);
        _TextVisualizationManager_visualizationNode.set(this, new viewer_1.TreeNode('TextVisualizationNode'));
        _TextVisualizationManager_distanceObject3D.set(this, void 0);
        _TextVisualizationManager_object3D.set(this, void 0);
        _TextVisualizationManager_positionObject3D.set(this, void 0);
        _TextVisualizationManager_showDistanceLabels.set(this, true);
        _TextVisualizationManager_showPointLabels.set(this, true);
        _TextVisualizationManager_prevWidth.set(this, 0);
        _TextVisualizationManager_prevHeight.set(this, 0);
        __classPrivateFieldSet(this, _TextVisualizationManager_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _TextVisualizationManager_viewport, drawingToolsManager.viewport, "f");
        __classPrivateFieldSet(this, _TextVisualizationManager_settings, drawingToolsManager.settings, "f");
        __classPrivateFieldSet(this, _TextVisualizationManager_parentNode, drawingToolsManager.parentNode, "f");
        __classPrivateFieldSet(this, _TextVisualizationManager_labelRenderer, new CSS2DRenderer_1.CSS2DRenderer(), "f");
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").setSize(__classPrivateFieldGet(this, _TextVisualizationManager_viewport, "f").canvas.clientWidth, __classPrivateFieldGet(this, _TextVisualizationManager_viewport, "f").canvas.clientHeight);
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.style.userSelect = 'none';
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.style.cursor = 'default';
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.style.pointerEvents = 'none';
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.style.overflow = 'hidden';
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.style.position = 'absolute';
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.style.width = '100%';
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.style.height = '100%';
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.style.left = '0%';
        __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.style.top = '0%';
        __classPrivateFieldGet(this, _TextVisualizationManager_viewport, "f").canvas.parentElement.appendChild(__classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement);
        __classPrivateFieldGet(this, _TextVisualizationManager_viewport, "f").postRenderingCallback = (renderer, scene, camera) => {
            if (__classPrivateFieldGet(this, _TextVisualizationManager_prevWidth, "f") !== renderer.domElement.clientWidth || __classPrivateFieldGet(this, _TextVisualizationManager_prevHeight, "f") !== renderer.domElement.clientHeight) {
                __classPrivateFieldSet(this, _TextVisualizationManager_prevWidth, renderer.domElement.clientWidth, "f");
                __classPrivateFieldSet(this, _TextVisualizationManager_prevHeight, renderer.domElement.clientHeight, "f");
                __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").setSize(renderer.domElement.clientWidth, renderer.domElement.clientHeight);
            }
            if (__classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.clientWidth !== renderer.domElement.clientWidth || __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").domElement.clientHeight !== renderer.domElement.clientHeight) {
                __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").setSize(renderer.domElement.clientWidth, renderer.domElement.clientHeight);
            }
            __classPrivateFieldGet(this, _TextVisualizationManager_labelRenderer, "f").render(scene, camera);
        };
        __classPrivateFieldSet(this, _TextVisualizationManager_object3D, new THREE.Object3D(), "f");
        __classPrivateFieldSet(this, _TextVisualizationManager_positionObject3D, new THREE.Object3D(), "f");
        __classPrivateFieldGet(this, _TextVisualizationManager_positionObject3D, "f").visible = __classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").visualization.pointLabels;
        __classPrivateFieldSet(this, _TextVisualizationManager_distanceObject3D, new THREE.Object3D(), "f");
        __classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f").visible = __classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").visualization.distanceLabels;
        __classPrivateFieldGet(this, _TextVisualizationManager_object3D, "f").add(__classPrivateFieldGet(this, _TextVisualizationManager_positionObject3D, "f"));
        __classPrivateFieldGet(this, _TextVisualizationManager_object3D, "f").add(__classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f"));
        __classPrivateFieldSet(this, _TextVisualizationManager_showPointLabels, __classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").visualization.pointLabels, "f");
        __classPrivateFieldSet(this, _TextVisualizationManager_showDistanceLabels, __classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").visualization.distanceLabels, "f");
        const node = new viewer_1.TreeNode('ThreeJsDataNode');
        const data = new viewer_1.ThreejsData(__classPrivateFieldGet(this, _TextVisualizationManager_object3D, "f"));
        node.addData(data);
        __classPrivateFieldGet(this, _TextVisualizationManager_visualizationNode, "f").addChild(node);
        __classPrivateFieldGet(this, _TextVisualizationManager_visualizationNode, "f").updateVersion();
        __classPrivateFieldGet(this, _TextVisualizationManager_parentNode, "f").addChild(__classPrivateFieldGet(this, _TextVisualizationManager_visualizationNode, "f"));
        __classPrivateFieldGet(this, _TextVisualizationManager_parentNode, "f").updateVersion(false, false);
        __classPrivateFieldGet(this, _TextVisualizationManager_viewport, "f").updateNode(__classPrivateFieldGet(this, _TextVisualizationManager_parentNode, "f"));
        this.createPointLabels();
        this.createDistanceLabels();
        (0, viewer_1.addListener)(viewer_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, () => {
            this.createPointLabels();
            this.createDistanceLabels();
        });
        (0, viewer_1.addListener)(viewer_1.EVENTTYPE_DRAWING_TOOLS.MOVED, () => {
            this.createPointLabels();
            this.createDistanceLabels();
        });
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (4)
    get showDistanceLabels() {
        return __classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f").visible;
    }
    set showDistanceLabels(value) {
        __classPrivateFieldSet(this, _TextVisualizationManager_showDistanceLabels, value, "f");
        if (__classPrivateFieldGet(this, _TextVisualizationManager_showDistanceLabels, "f")) {
            this.createDistanceLabels();
        }
        else {
            __classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f").remove(...__classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f").children);
        }
    }
    get showPointLabels() {
        return __classPrivateFieldGet(this, _TextVisualizationManager_showPointLabels, "f");
    }
    set showPointLabels(value) {
        __classPrivateFieldSet(this, _TextVisualizationManager_showPointLabels, value, "f");
        if (__classPrivateFieldGet(this, _TextVisualizationManager_showPointLabels, "f")) {
            this.createPointLabels();
        }
        else {
            __classPrivateFieldGet(this, _TextVisualizationManager_positionObject3D, "f").remove(...__classPrivateFieldGet(this, _TextVisualizationManager_positionObject3D, "f").children);
        }
    }
    // #endregion Public Getters And Setters (4)
    // #region Public Methods (3)
    close() {
        __classPrivateFieldGet(this, _TextVisualizationManager_positionObject3D, "f").remove(...__classPrivateFieldGet(this, _TextVisualizationManager_positionObject3D, "f").children);
        __classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f").remove(...__classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f").children);
    }
    createDistanceLabels() {
        if (!__classPrivateFieldGet(this, _TextVisualizationManager_showDistanceLabels, "f"))
            return;
        __classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f").remove(...__classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f").children);
        const positionArray = __classPrivateFieldGet(this, _TextVisualizationManager_drawingToolsManager, "f").positionArray;
        const indicesArrayLines = __classPrivateFieldGet(this, _TextVisualizationManager_drawingToolsManager, "f").indicesArrayLines;
        if (!indicesArrayLines || positionArray.length <= 3)
            return;
        for (let i = 0; i < indicesArrayLines.length; i += 2) {
            // calculate the midpoint of the line
            const firstIndex = indicesArrayLines[i];
            const secondIndex = indicesArrayLines[i + 1];
            const firstPoint = gl_matrix_1.vec3.fromValues(positionArray.at(firstIndex * 3), positionArray.at(firstIndex * 3 + 1), positionArray.at(firstIndex * 3 + 2));
            const secondPoint = gl_matrix_1.vec3.fromValues(positionArray.at(secondIndex * 3), positionArray.at(secondIndex * 3 + 1), positionArray.at(secondIndex * 3 + 2));
            const midPoint = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), firstPoint, secondPoint);
            gl_matrix_1.vec3.scale(midPoint, midPoint, 0.5);
            const text = document.createElement('div');
            text.className = 'label';
            text.style.marginTop = '1em';
            const child = document.createElement('div');
            child.className = 'distance-label';
            // check if there is already a style tag in the head that defined the style for the point label
            // if not, create one
            let styleExists = false;
            document.head.querySelectorAll('style').forEach(style => {
                var _a;
                if ((_a = style.textContent) === null || _a === void 0 ? void 0 : _a.includes('.distance-label')) {
                    styleExists = true;
                    return;
                }
            });
            if (!styleExists) {
                const style = document.createElement('style');
                style.textContent = `
                    .distance-label {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: white;
                        background-color: ${__classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").visualization.points.color_1}80;
                        border-radius: 5px;
                        font-size: 16px;
                        text-align: center;
                        padding: 0px 2px;
                    }
                `;
                document.head.appendChild(style);
            }
            child.textContent = `${(0, numberCleaner_1.numberCleaner)(gl_matrix_1.vec3.distance(firstPoint, secondPoint))}${__classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").general.displayUnit}`;
            text.appendChild(child);
            const label = new CSS2DRenderer_1.CSS2DObject(text);
            label.position.set(midPoint[0], midPoint[1], midPoint[2]);
            __classPrivateFieldGet(this, _TextVisualizationManager_distanceObject3D, "f").add(label);
        }
    }
    createPointLabels() {
        if (!__classPrivateFieldGet(this, _TextVisualizationManager_showPointLabels, "f"))
            return;
        __classPrivateFieldGet(this, _TextVisualizationManager_positionObject3D, "f").remove(...__classPrivateFieldGet(this, _TextVisualizationManager_positionObject3D, "f").children);
        const positionArray = __classPrivateFieldGet(this, _TextVisualizationManager_drawingToolsManager, "f").positionArray;
        for (let i = 0; i < positionArray.length; i += 3) {
            const text = document.createElement('div');
            text.className = 'label';
            text.style.marginTop = '1em';
            const child = document.createElement('div');
            child.className = 'point-label';
            // check if there is already a style tag in the head that defined the style for the point label
            // if not, create one
            let styleExists = false;
            document.head.querySelectorAll('style').forEach(style => {
                var _a;
                if ((_a = style.textContent) === null || _a === void 0 ? void 0 : _a.includes('.point-label')) {
                    styleExists = true;
                    return;
                }
            });
            if (!styleExists) {
                const style = document.createElement('style');
                style.textContent = `
                    .point-label {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: white;
                        background-color: ${__classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").visualization.points.color_1}80;
                        border-radius: 5px;
                        font-size: 16px;
                        text-align: center;
                        padding: 0px 2px;
                    }
                `;
                document.head.appendChild(style);
            }
            child.textContent = `[${(0, numberCleaner_1.numberCleaner)(positionArray[i])}${__classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").general.displayUnit}, ${(0, numberCleaner_1.numberCleaner)(positionArray[i + 1])}${__classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").general.displayUnit}, ${(0, numberCleaner_1.numberCleaner)(positionArray[i + 2])}${__classPrivateFieldGet(this, _TextVisualizationManager_settings, "f").general.displayUnit}]`;
            text.appendChild(child);
            const label = new CSS2DRenderer_1.CSS2DObject(text);
            label.position.set(positionArray[i], positionArray[i + 1], positionArray[i + 2]);
            __classPrivateFieldGet(this, _TextVisualizationManager_positionObject3D, "f").add(label);
        }
    }
}
exports.TextVisualizationManager = TextVisualizationManager;
_TextVisualizationManager_drawingToolsManager = new WeakMap(), _TextVisualizationManager_labelRenderer = new WeakMap(), _TextVisualizationManager_parentNode = new WeakMap(), _TextVisualizationManager_settings = new WeakMap(), _TextVisualizationManager_viewport = new WeakMap(), _TextVisualizationManager_visualizationNode = new WeakMap(), _TextVisualizationManager_distanceObject3D = new WeakMap(), _TextVisualizationManager_object3D = new WeakMap(), _TextVisualizationManager_positionObject3D = new WeakMap(), _TextVisualizationManager_showDistanceLabels = new WeakMap(), _TextVisualizationManager_showPointLabels = new WeakMap(), _TextVisualizationManager_prevWidth = new WeakMap(), _TextVisualizationManager_prevHeight = new WeakMap();
//# sourceMappingURL=TextVisualizationManager.js.map